export const PATH_BUBBLES = '/bubbles'
export const PATH_THEORY = '/theory'
export const PATH_WELCOME = '/'

export const TOKEN_TYPE_IDENTIFIER = 'Identifier'
